import type { PlayerPalette } from "./types.ts";

export const DEFAULT_PALETTE_NEUTRAL = {
  main: "#f1f1f1",
  foreground: "#000000",
  light: "#ffffff",
  dark: "#d3d3d3",
} satisfies PlayerPalette;

export const DEFAULT_PALETTE_SELECTED = {
  main: "#33B2E1",
  foreground: "#ffffff",
  light: "#52D1FF",
  dark: "#3385A4",
} satisfies PlayerPalette;
